<template>
    <ValidationProvider
        :mode="validationMode"
        :name="label || name || 'unknown'"
        :rules="rules"
        :vid="id"
        v-slot="{ validated, valid, errors }"
        slim
    >
        <rkm-form-group
            :invalid-feedback="errors[0]"
            :state="rules ? (validated ? valid : null) : null"
            :class="{ 'placeholder-label': label === false }"
        >
            <template v-if="label">
                <div class="float-left">
                    <label :for="id">
                        {{ label + (rules && rules.required ? ' *' : '') }}
                    </label>
                </div>

                <slot name="label-right" />
            </template>

            <template v-if="tooltipText">
                <rkm-tooltip target="btn" :placement="tooltipPosition">
                    {{ tooltipText }}
                </rkm-tooltip>

                <rkm-button color="fill" id="btn">
                    <rkm-icon icon="info-circle"></rkm-icon>
                </rkm-button>
            </template>

            <rkm-input-group
                :append="append"
                :large="groupLarge"
                :prepend="prepend"
                :small="groupSmall"
                :class="inputGroupClass"
                class="flex-nowrap"
            >
                <template v-if="!prepend && $slots.prepend" v-slot:prepend>
                    <slot name="prepend" />
                </template>

                <b-form-input
                    :style="`${danger ? `background-color: #ffe1e1; border: 1px solid #dc3545` : ''}`"
                    v-trim="trim"
                    v-mask="mask"
                    v-number="number"
                    v-uppercase="uppercase"
                    v-alpha="alpha"
                    v-alpha-space="alphaSpace"
                    :autocomplete="autocomplete"
                    :disabled="disabled"
                    :formatter="formatter"
                    :id="id"
                    :max="(rules && rules.max) || ''"
                    :maxlength="(rules && rules.max) || ''"
                    :min="(rules && rules.min) || ''"
                    :number="type === 'number'"
                    :placeholder="placeholder"
                    :readonly="readonly"
                    :required="required"
                    :size="size"
                    :state="rules ? (validated ? valid : null) : null"
                    :type="type"
                    :value="value"
                    :debounce="debounce"
                    :step="step"
                    @blur="handleBlur"
                    @click="$emit('click', $event)"
                    @change="$emit('change', $event)"
                    @focus="$emit('focus', $event)"
                    @input="$emit('input', $event)"
                    @keypress="$emit('keypress', $event)"
                    @submit="$emit('submit', $event)"
                    @update="$emit('update', $event)"
                />

                <template v-if="!append && $slots.append" v-slot:append>
                    <slot name="append" />
                </template>
            </rkm-input-group>
        </rkm-form-group>
    </ValidationProvider>
</template>

<script>
import { BFormInput } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate';

export default {
    components: { BFormInput, ValidationProvider },
    computed: {
        size() {
            return this.small ? 'sm' : (this.large ? 'lg' : (''))
        },
        tooltipPosition() {
            if(this.tooltipTop)
                return 'top'
            else if(this.tooltipRight)
                return 'right'
            else if(this.tooltipBottom)
                return 'bottom'
            else if(this.tooltipLeft)
                return 'left'

            return ''
        },
        tooltipText() {
            return this.tooltipTop
                || this.tooltipRight
                || this.tooltipBottom
                || this.tooltipLeft
        },
        id() {

            // TODO: Centralizar e a tratar melhor a string, removendo caracteres especiais, acentos, etc.
            const id = (this.label || this.name || 'unknown')
                .toLowerCase()
                .replace(/[()\\/\-<>]/gi, '')
                .replace(/[\s]/gi, '-')

            return this.uniqueId(id)
        },
        rules() {

            return this.disabled ? null : this.validations
        }
    },
    methods: {
        handleBlur(event) {

            if (typeof this.value === 'string') {

                const value = this.value.trim()

                event.target.value = value

                this.$emit('input', value)
            }

            this.$emit('blur', event)
        },
    },
    props: {
        alpha: { type: Boolean, default: false },
        alphaSpace: { type: Boolean, default: false },
        append: { type: String, default: null },
        autocomplete: { type: String, default: 'off' },
        debounce: { type: [Number, String], default: 0 },
        disabled: { type: Boolean },
        formatter: { type: Function },
        groupLarge: { type: Boolean, default: false },
        groupSmall: { type: Boolean, default: false },
        inputGroupClass: { type: String, default: '' },
        label: { type: [String, Boolean], default: '' },
        large: { type: Boolean, default: false },
        mask: { type: String, default: '' },
        name: { type: String },
        number: { type: Boolean, default: false },
        placeholder: { type: String },
        prepend: { type: String, default: null },
        readonly: { type: Boolean, default: false },
        required: { type: Boolean, default: false },
        small: { type: Boolean, default: false },
        state: { type: Boolean, default: null },
        tooltipBottom: { type: String },
        tooltipLeft: { type: String },
        tooltipRight: { type: String },
        tooltipTop: { type: String },
        type: { type: String, default: 'text' },
        uppercase: { type: Boolean },
        validationMode: { type: String, default: 'aggressive' },
        validations: { type: Object, default: null },
        value: { type: [Date, Number, String], default: '' },
        trim: { type: Boolean, default: true },
        step: { type: String, default: "1" },
        danger: { type: Boolean, default: false }
    }
}
</script>

<style scoped>
button {
    float: left;
    margin-top: -6px
}
</style>